/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const cmsModule = require('@utils/cms/cmsModule');
const commonModule = require('@utils/common/commonModule');
const consumersModule = require('@utils/consumers/consumersModule');
const solarModule = require('@utils/solar/solarModule');

const FlatPageService = require('./flatPageService');
const FlatPageController = require('./flatPageController');
const flatPageHtmlDirective = require('./flatPageHtml/flatPageHtmlDirective');

const flatPageModule = angular
    .module('enervee_utils.flat_page', [
        cmsModule.name,
        commonModule.name,
        consumersModule.name,
        solarModule.name,
    ])
    .factory('FlatPageService', FlatPageService)
    .controller('FlatPageCtrl', FlatPageController)
    .directive('flatPageHtml', flatPageHtmlDirective);

module.exports = flatPageModule;